import { render, staticRenderFns } from "./Jxjh.vue?vue&type=template&id=6e4420f8&scoped=true"
import script from "./Jxjh.vue?vue&type=script&lang=js"
export * from "./Jxjh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4420f8",
  null
  
)

export default component.exports